import BindingContext from "@odata/BindingContext";
import { BalancingPeriodOverviewWrapper } from "@pages/payroll/attendance/Attendance.styles";
import FormTableList from "@pages/payroll/payslip/formTableList/FormTableList";
import OverviewBase, { IOverviewBaseProps } from "@pages/payroll/payslip/overview/OverviewBase";
import { getBalancingPeriodBilanceSections, getBalancingPeriodFundSections } from "@pages/payroll/payslip/Payslip.utils";
import { memoizeOne } from "@utils/memoizeOne";
import React from "react";

import { getEntityMemoKey } from "../../../../views/formView/Form.utils";

interface IProps extends IOverviewBaseProps {
    employmentBindingContext: BindingContext;
}

export default class BalancingPeriodOverview extends OverviewBase<IProps> {
    _isEditable = false;

    getFundSections = memoizeOne(() => {
        return getBalancingPeriodFundSections(this.props.storage, this.props.employmentBindingContext);
    }, () => [getEntityMemoKey(this.props.storage), this.props.employmentBindingContext.getFullPath()]);

    getBilanceSections = memoizeOne(() => {
        return getBalancingPeriodBilanceSections(this.props.storage, this.props.employmentBindingContext);
    }, () => [getEntityMemoKey(this.props.storage), this.props.employmentBindingContext.getFullPath()]);

    getSections = this.getFundSections;

    render(): React.ReactElement {
        const fundSections = this.getFundSections();
        const bilanceSections = this.getBilanceSections();

        return <BalancingPeriodOverviewWrapper>
            {fundSections.map((fundSection, index) => (
                <React.Fragment key={index}>
                    <FormTableList sections={[fundSection]} isEditable={false}/>
                    <FormTableList sections={[bilanceSections[index]]} isEditable={false} hasDynamicColumns/>
                </React.Fragment>
            ))}
        </BalancingPeriodOverviewWrapper>;
    }
}
